import type { FaireProductEntity } from "../../entity_types/product";

export const p_7xc38yc6gq: FaireProductEntity = {
  token: "p_7xc38yc6gq",
  type: "product",
  name: "*NEW* Unicorn Mineral Makeup Gift Set",
  brandToken: "b_1x9epn75if",
  brandName: "Prim and Pure",
  imageUrl:
    "https://cdn.faire.com/fastly/233db1e1026c09baff03fcf01715bb81099d7911ccd9aaee5e9ce5a8710898e9.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/ea655dc51d5977ff716374cfc971ee177890959ceb950b6ccd27e8a8c0a300fd.jpeg",
    "https://cdn.faire.com/fastly/982f55ed1af3f7cc98f10e9715a572271dc6a61e76c695d16b086f79f2492b73.jpeg",
    "https://cdn.faire.com/fastly/627d6f4827e90194e46b96958fcecd3513dd0f1c0ba18dbef0fe4b08c43d5d94.jpeg",
    "https://cdn.faire.com/fastly/542adb47d88f76d31e4316ae4a4ad7db83d747ebf643b4cb6f37f7427ec5cb30.jpeg",
    "https://cdn.faire.com/fastly/1ea89aa3d2cfa254bb99df0943de40044df1e0a275caa673d020b101dd73249f.jpeg",
    "https://cdn.faire.com/fastly/9e4e90e347620cf6a6e7a19efad512946b1142ea4ec21f1ff71de89eaa16de7b.jpeg",
    "https://cdn.faire.com/fastly/9b858c25fede20c91a3e275a15afe4efeb79a33f1620c0304f7698a8e539b04b.jpeg",
    "https://cdn.faire.com/fastly/a4c16fa77fdf8f511cb11a4cfac69e9ed5b460af84ea96d8092c2c9e8653892f.jpeg",
    "https://cdn.faire.com/fastly/b47b994c2b4294d073fdd082221990cb7963baa698290fc5143992cd31ac96bb.png",
    "https://cdn.faire.com/fastly/37fa37c2acb7f873b4f8fdb41e05039a940eac96317a0eb8ddf80a78edc3d6f9.jpeg",
  ],
  priceDollars: 18.99,
  description:
    "\nDescription:\n\nA new version of our most popular seller - the Unicorn Gift Set! This set contains mineral makeup products along with adorably fun accessories ready for play right out of the box! \n\nContents:\n\nEach boxed set includes (2) Full Sized Mineral Eyeshadows AND (2) Pure Play Mineral Lip Glosses (Light Pink and Clear White Sparkle). Accessories included in this set are: 1 Unicorn Mirror, 1 Unicorn Theme Stencil, and 3 Piece Brush Set all packaged in a fun zippered cloth cosmetic bag. \n\n\nIngredients: \n\nEyeshadows: High Quality Sustainable Mica Mineral Pigments.\n\nLip Gloss: Organic Castor Oil, Organic Shea Butter, Mica Mineral Pigments, and Essential Oil Blend of Lemon, Sweet Orange and Pink Grapefruit.\n\nMade in the USA, Non-Toxic, Sustainable, Non-GMO, Cruelty Free, Paraben Free\n",
  tags: [],
  msrpDollars: 35.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T19:26:12.441Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
